import { Card, Spinner } from 'components';
import React from 'react';
import { I18n } from 'core';
import { t } from 'i18n-js';
import { ReactComponent as PendingIcon } from 'assets/icons/community_pending.svg';

import { Colors } from 'styles';
import { useHistory } from 'react-router-dom';
import { FormatNumberService } from 'services';

import styles from './solicitudes-pendientes.module.scss';

interface SolicitudesPendientesProps {
  pending: number;
  type: 'nuevo-onboarding' | 'onboarding';
}

export const SolicitudesPendientes = (props: SolicitudesPendientesProps): JSX.Element => {
  const { pending, type } = props;
  const i18nPrefix = `DashboardPage.SolicitudesPendientes`;
  const history = useHistory();

  const isOnboarding =
    type === 'nuevo-onboarding' ? '/tecnic/solicitudes-pendientes-new-onboarding' : '/tecnic/solicitudes-pendientes';
  return (
    <Card
      fullHeight
      title={`${I18n.t(`${i18nPrefix}.title`)} ${type}`}
      body={[
        <div className={styles.root}>
          <div className={styles.section}>
            <PendingIcon stroke={Colors.COLOR_EXCEDENTS} height={50} width={50} />
            <span className={styles.value}>
              {pending >= 0 ? FormatNumberService.formatInteger(`${pending}`) : <Spinner size={30} />}
            </span>
            <p className={styles.label}>{t(`${i18nPrefix}.pending`)}</p>
            <button
              className={styles.viewmore_button}
              type="button"
              onClick={() => {
                history.push(isOnboarding);
              }}
            >
              {I18n.t(`${i18nPrefix}.viewmore`)}
            </button>
          </div>
        </div>,
      ]}
    />
  );
};
